module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('step', {
    attrs: {
      "navItems": _vm.navItems,
      "step": 0,
      "index": 0
    },
    on: {
      "back": function () {
        this$1.$router.push('/group-mgr')
      },
      "finish": function () {
        this$1.$router.push('/group-mgr')
      }
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h3', [_vm._v("上傳Excel檔案")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./static/files/老師端學生匯入格式.xlsx",
      "download": ""
    }
  }, [_vm._v("下載範例檔案")])]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-8 offset-2"
  }, [(_vm.uploadReady) ? _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "file",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-flush"
  }, [(_vm.file === null) ? _c('li', {
    staticClass: "list-group-item border text-left mb-3",
    staticStyle: {
      "line-height": "150%",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.$refs.file.click()
      }
    }
  }, [_c('div', {
    staticClass: "float-left"
  }, [_vm._v("\n                點擊選擇要上傳的附件(請從您的電腦裡選擇要上傳的檔案)"), _c('br'), _vm._v("\n                一次只能上傳一個檔案\n              ")])]) : _c('li', {
    staticClass: "list-group-item border text-left mb-3",
    staticStyle: {
      "line-height": "150%"
    }
  }, [_c('div', {
    staticClass: "float-left"
  }, [_vm._v("\n                " + _vm._s(_vm.file.name)), _c('br'), _vm._v(_vm._s(Math.round(_vm.file.size / 1024 / 1024)) + " MB\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "float-right"
  }, [_c('span', {
    staticClass: "btn btn-xs p-0",
    on: {
      "click": function($event) {
        _vm.upload()
      }
    }
  }, [(false) ? _c('img', {
    attrs: {
      "src": require("../../assets/image/icon/upload_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/image/icon/upload_off.png")
    }
  })])])]), _vm._v(" "), (_vm.progress > -1) ? _c('li', {
    staticClass: "list-group-item text-left mb-3 border-0 clearfix pt-4"
  }, [_c('div', {
    staticClass: "float-left"
  }, [_vm._v("上傳進度：")]), _vm._v(" "), _c('div', {
    staticClass: "progress mt-2",
    staticStyle: {
      "height": "0.2rem"
    }
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-danger progress-bar-striped active",
    style: ({
      width: _vm.progress + '%',
      'border-width': '1px'
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.progress,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.progress) + "% " + _vm._s('完成'))])])]), _vm._v(" "), _c('icon-button', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0"
    },
    attrs: {
      "name": "cancelUpload"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelUpload()
      }
    }
  })], 1) : _vm._e()])])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68488acc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teacher/TeachingGroupAddStudentByExcel.vue
// module id = 737
// module chunks = 1